import request from "@/utils/request";

// 帐密登录
export const accountLogin = (params) => {
  return request("/system/login", {
    method: "POST",
    data: params,
  });
};

// 获取公司
export async function getCompanyList(token) {
  return request("/system/companyRegList", {
    method: "POST",
    headers: {
      Authorization: token,
    },
  });
}

// 获取新token
export async function loginWithCompany({ token, ...data }) {
  return request("/system/refrehToken", {
    method: "POST",
    headers: {
      Authorization: token,
    },
    data,
  });
}

/**
 * 获取微前端子应用 Token
 */
export const getMicroWebToken = () => {
  return request("/system/getMicroWebToken", {
    method: "POST",
  });
};

/**
 * 公司员工列表
 */
export const getEmployeeListApi = (params) => {
  return request("/employee/list", {
    method: "POST",
    data: params,
  });
};
